import moment from 'moment'
import { IUserProps } from './User'
import { IFileProps } from './File'
import { MessageProperties, RelationHospital } from '@/infrastructure/network/Monitaro/schema/models'

export interface IMessageProps {
  id?: string
  hospitalId: string | null
  hospital?: RelationHospital | null
  users?: IUserProps[]
  industries: string[] | null
  readsCount: number | null
  type: string | null
  from: string | null
  title: string | null
  content: string | null
  temporary?: string | null
  sentAt: string | null
  createdAt: string | null
  updatedAt: string | null
  properties: MessageProperties | null
  files: IFileProps[]
}

export interface IMessageQueryProps {
  hospitalId: string | null
}

export default class MessageEntity {
  private _props: IMessageProps

  constructor(props?: IMessageProps | null) {
    this._props = EmptyMessagePropsFactory(props)
  }

  get props(): IMessageProps {
    return this._props
  }

  get clone(): IMessageProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get type(): string | null {
    return this._props.type
  }

  get from(): string | null {
    return this._props.from
  }

  get organization(): string | null {
    return this._props.hospital?.name || null
  }

  get title(): string | null {
    return this._props.title
  }

  get content(): string | null {
    return this._props.content
  }

  get sentAt(): string | null {
    return this._props.sentAt ? moment(this._props.sentAt).format('YYYY年M月D日') : null
  }

  get createdAt(): string | null {
    return this._props.createdAt ? moment(this._props.createdAt).format('YYYY年M月D日 HH:mm') : null
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get properties(): MessageProperties | null | undefined {
    return this._props.properties
  }

  get files(): IFileProps[] {
    return this._props.files
  }
}

export const headers = [
  { text: '作成日時', value: 'createdAt' },
  { text: 'メール送信者名', value: 'from' },
  { text: '内容', value: 'content' },
  { text: '送信種別', value: 'delivery' },
  { text: '送信日時', value: 'sentAt' }
]

export const types = [
  { text: 'すべての担当者に通知する', value: 'broadcast' },
  { text: '担当者を選択して通知する', value: 'direct' },
  { text: '業種で選択して通知する', value: 'industries' }
]

export const EmptyMessagePropsFactory = (props?: Partial<IMessageProps> | null): IMessageProps => ({
  hospitalId: null,
  industries: null,
  readsCount: null,
  type: null,
  from: null,
  title: null,
  content: null,
  sentAt: null,
  createdAt: null,
  updatedAt: null,
  files: [],
  ...props,
  properties: EmptyMessagePropertiesFactory(props?.properties)
})

export const EmptyMessagePropertiesFactory = (props?: Partial<MessageProperties> | null): MessageProperties => ({
  temporary: null,
  delivery: null,
  users: null,
  industries: null,
  ...props
})
